export enum Environment {
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'prod',
}
